<template>
  <div class="Details felx flex_jc_sb">
    <DetailsLeft></DetailsLeft>
    <DetailsRight></DetailsRight>
  </div>
</template>
<script>
import DetailsLeft from '@/views/LabourService/RentInformationDetails/DetailsLeft'// 详情左
import DetailsRight from '@/views/LabourService/RentInformationDetails/DetailsRight'// 详情左
export default {
  name: 'Details',
  components: {
    DetailsLeft,
    DetailsRight
  },
  data () {
    return {

    }
  },
  computed: {},
  methods: {

  },
  watch: {},
  created () {},
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
/* 面包屑 */
  .Details {
    width: 1170px;
    margin: 0 auto;
    overflow: hidden;
}

.floatLeft {
  float: left;
}
.clearB {
  clear: both;
}
</style>
